import React from "react";
import { history } from 'react-router-guard';
import "./buildings-section.component.scoped.scss";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { addLeadingZero } from "../../helpers";
import { useTranslation } from "react-i18next";
import { icons } from "src/statics/icons";
const { homeBlueIco } = icons;

export const BuildingsSectionComponent = (props: any) => {
  const [t] = useTranslation();
  return (
    <div className="buildings">
      <TableContainer component={Paper}>
        <Table aria-label="buildings table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>{t('hours-operations')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.buildings.map((row: any, index: number) => (
              <BuildingRow index={index} info={row} key={index}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!props.buildings.length && <div className="no-result">No buildings Found.</div>}
    </div>
  );
};

export const BuildingRow = (props: any) => {
  const {index, info} = props;
  const openBuilding = (row: any) => {
    history.push(`/statistics/${row.building.id}`);
  };
  return (
  <TableRow key={index} onClick={openBuilding.bind(null, info)} className="building-row">
    <TableCell>
      <div className="building-info">
        <div className="profile-picture">
          <img
            src={homeBlueIco}
            alt=""
            className="building-ico"
          />
        </div>
        <div className="building-name">
          <span className="title">{info.building.name}</span>
          <br />
          <span className="subtitle">{info.building.address}</span>
        </div>
      </div>
    </TableCell>
    <TableCell>{`${addLeadingZero(info.workingHours?.hours)}:${addLeadingZero(info.workingHours?.minutes)} / ${info.tasks}`}</TableCell>
  </TableRow>
  )
}